$(document).ready(function () { $("a[href^='#']").click(function () { var t; return t = $($(this).attr("href")), 0 != t.length ? ($("html, body").animate({ scrollTop: t.offset().top }), !1) : void 0 }) });
